// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  SafetyDriverGuidanceAreaId,
  SafetyDriverGuidanceAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  SafetyDriverGuidanceAreaNavigation,
  SafetyDriverGuidanceAreaNavigationIcon,
} from './SafetyDriverGuidanceAreaNavigation'

const LazySafetyDriverGuidanceComponent = lazy(
  () => import('./SafetyDriverGuidanceArea'),
)

const SafetyDriverGuidanceComponent = () => (
  <SuspenseLoadingWrapper>
    <LazySafetyDriverGuidanceComponent />
  </SuspenseLoadingWrapper>
)

export const SafetyDriverGuidanceArea = {
  id: SafetyDriverGuidanceAreaId,
  requiredRight: BoumRight.AREA_SAFETY_DRIVER_INTERFACE,
  Icon: SafetyDriverGuidanceAreaNavigationIcon,
  NavigationComponent: SafetyDriverGuidanceAreaNavigation,
  route: {
    path: SafetyDriverGuidanceAreaRoutes.route,
    component: SafetyDriverGuidanceComponent,
  },
}
